module.exports = "/packs/templates.checkout-object-detail-1bde216a.html";